module.exports = __webpack_public_path__ + "static/1-d8f2487535176967493bc783fef3a2c6.jpg";